/**
 * Integrations Module
 */
(function () {
    "use strict";

    angular.module("elogbooks.user.integrations", []);
})();
